import { createSlice, PayloadAction } from '@reduxjs/toolkit';

function AppStateViews() {
	return {
		INIT: 'INIT',
		API_LOADING: 'API_LOADING',
		API_ERROR: 'API_ERROR',
		APP_UI: 'APP_UI',
	};
}

const { INIT, API_LOADING, API_ERROR, APP_UI } = AppStateViews();

export interface CounterState {
	uiView: string;
}

const initialState: CounterState = {
	uiView: '',
};

export const mainAppSlice = createSlice({
	name: 'label',
	initialState,
	reducers: {
		updateUiView: (state, action: PayloadAction<string>) => {
			state.uiView = action.payload;
		},
		init: (state) => {
			state.uiView = INIT;
		},
		apiLoading: (state) => {
			state.uiView = API_LOADING;
		},
		apiError: (state) => {
			state.uiView = API_ERROR;
		},
		appUi: (state) => {
			state.uiView = APP_UI;
		},
	},
});

export const { init, apiLoading, apiError, appUi } = mainAppSlice.actions;

export const mainAppReducer = mainAppSlice.reducer;
